import Helpers from '../helpers';

export const REQ_GET_NOTES = 'REQ_GET_NOTES';
export const RES_GET_NOTES = 'RES_GET_NOTES';
export const GET_NOTES_ERROR = 'GET_NOTES_ERROR';
export const REQ_REMOVE_NOTE = 'REQ_REMOVE_NOTE';
export const RES_REMOVE_NOTE = 'RES_REMOVE_NOTE';
export const REMOVE_NOTE_ERROR = 'REMOVE_NOTE_ERROR';
export const REQ_SAVE_NOTE = 'REQ_SAVE_NOTE';
export const RES_SAVE_NOTE = 'RES_SAVE_NOTE';
export const SAVE_NOTE_ERROR = 'SAVE_NOTE_ERROR';
export const NEW_NOTE = 'NEW_NOTE';
export const COMPONENT_CLICKED = 'COMPONENT_CLICKED';
export const REMOVE_MOUSEEVENT_LISTENER = 'REMOVE_MOUSEEVENT_LISTENER';
export const ADD_MOUSEEVENT_LISTENER = 'ADD_MOUSEEVENT_LISTENER';
export const SET_ANNOTATION_STATUS = 'SET_ANNOTATION_STATUS';
export const SET_CURRENT_COMPONENT_TARGET = 'SET_CURRENT_COMPONENT_TARGET';

export const requestNotes = url => ({
	type: REQ_GET_NOTES,
	url
})

export const requestRemoveNote = note_id => ({
	type: REQ_REMOVE_NOTE,
	note_id
})

export const requestSaveNote = note => ({
	type: REQ_SAVE_NOTE,
	note
})

export const responseSaveNote = note_id => ({
	type: RES_SAVE_NOTE
})

export const responseRemoveNote = note_id => ({
	type: RES_REMOVE_NOTE,
	note_id
})

export const receiveNotes = (url, data) => ({
	type: RES_GET_NOTES,
	url,
	notes: data.notes,
	author: data.author
})

export const newNote = note => ({
	type: NEW_NOTE,
	note
})

export const saveNoteError = text => ({
	type: SAVE_NOTE_ERROR,
	text
})

export const getNotesError = text => ({
	type: GET_NOTES_ERROR,
	text
})

export const removeNoteError = text => ({
	type: REMOVE_NOTE_ERROR,
	text
})

export const componentClicked = e => ({
	type: COMPONENT_CLICKED,
	e
})

export const setAnnotationStatus = status => ({
	type: SET_ANNOTATION_STATUS,
	annotationStatus: status
})

const fetchNotes = url => dispatch => {
	dispatch(requestNotes(url))
	Helpers.post({
		action: 'webnotes_getnotes',
		url: window.location.href
	})
		.then(data => dispatch(receiveNotes(url, data)))
		.catch(function({status}) {
			getNotesError(status);
		});
}

const isFetchingNotes = ({notes}) => notes.isFetching;

const setCurrentComponentTarget = (target) => ({
	type: SET_CURRENT_COMPONENT_TARGET,
	target
});

const watchedComponents = ['article', 'footer', 'header'];

const componentEnter = function (e) {
	let dispatch = this.dispatch;
	if (e.target.tagName && watchedComponents.includes(e.target.tagName.toLowerCase())) {
		e.stopPropagation();
		e.target.style.outline = '4px dotted red';
		dispatch(setCurrentComponentTarget(e.target));
	}
}
const componentLeave = function (e) {
	let dispatch = this.dispatch;
	if (e.target.tagName && watchedComponents.includes(e.target.tagName.toLowerCase()) && e.target.closest(watchedComponents.join(',')) === null) {
		e.stopPropagation();
		e.target.style.outline = 'none';
		dispatch(setCurrentComponentTarget(null));
	}
}
const componentClick = function (e) {
	function isAnnotable(target) {
		return target.tagName && watchedComponents.includes(target.tagName.toLowerCase()) && target.style && ['inline', 'none'].indexOf(target.style.display) === -1 && !target.hasAttribute('data-webnotes-ui');
	}
	let dispatch = this.dispatch,
		state = this.getState();
	if (state.currentComponentTarget && isAnnotable(state.currentComponentTarget)) {
		dispatch(componentClicked(e));
		dispatch(annotationStatus('annotating'));
	}
}

export const removeMouseEventListener = eventtype => ({
	type: REMOVE_MOUSEEVENT_LISTENER,
	eventtype
})

export const addMouseEventListener = (eventtype, proc) => ({
	type: ADD_MOUSEEVENT_LISTENER,
	eventtype,
	proc
})

export const annotationStatus = status => (dispatch, getState) => {
	function checkAndRemoveEventListeners(eventtypes) {
		eventtypes.forEach(function (eventtype) {
			let handler = state.eventListeners[eventtype];
			if (typeof handler === 'function') {
				dispatch(removeMouseEventListener(eventtype, handler));
				document.removeEventListener(eventtype, handler);
			}
		});
	}
	function enableHover() {
		let handlers = {
			mouseover: componentEnter.bind({dispatch}),
			mouseout: componentLeave.bind({dispatch}),
			click: componentClick.bind({dispatch, getState})
		}
		for (let handler of Object.keys(handlers)) {
			checkAndRemoveEventListeners([handler]);
			document.addEventListener(handler, handlers[handler]);
			dispatch(addMouseEventListener(handler, handlers[handler]));
		}
	}
	function disableHover() {
		checkAndRemoveEventListeners(['mouseover', 'mouseout', 'click']);
	}
	let state = getState(),
		prevAnnotationStatus = state.annotationStatus;
	if (status !== prevAnnotationStatus) {
		switch (status) {
			case 'inactive':
				disableHover();
				break;
			case 'waiting':
				enableHover();
				break;
			case 'annotating':
				disableHover();
				break;
		}
		return dispatch(setAnnotationStatus(status));
	}
}

export const fetchNotesIfNeeded = url => (dispatch, getState) => {
	let {notes} = getState();
	if (!isFetchingNotes(getState()) && !notes) {
		return dispatch(fetchNotes(url));
	}
}

export const startSaveNote = note => (dispatch, getState) => {
	dispatch(requestSaveNote(note));
	Helpers.post({
		action: 'webnotes_savenote',
		note
	})
		.then(function(note_id) {
			dispatch(responseSaveNote());
			dispatch(newNote({...note, note_id}));
		})
		.catch(function({status}) {
			dispatch(saveNoteError(status));
		});
}

export const removeNote = note_id => (dispatch, getState) => {
	dispatch(requestRemoveNote(note_id));
	Helpers.post({
		action: 'webnotes_deletenote',
		note_id: note_id
	})
		.then(function(note_id) {
			dispatch(responseRemoveNote(note_id));
		})
		.catch(function({status}) {
			dispatch(removeNoteError(status));
		});
}


// WEBPACK FOOTER //
// ./src/js/actions/index.js